run.$inject = ['$rootScope', '$templateCache', '$state', '$stateParams', '$timeout', 'MenuConstant', 'workplan']

export default function run ($rootScope, $templateCache, $state, $stateParams, $timeout, MenuConstant, workplan, GlobalConfig) {
  $templateCache.put('courses-list', require('./teachingDevelopment/listTeacherJobsView/course-list.html'))
  $templateCache.put('course-details', require('./teachingDevelopment/listTeacherJobsView/course-details.html'))
  $templateCache.put('course-details-modal', require('./teachingDevelopment/listTeacherJobsView/course-details-modal.html'))
  $templateCache.put('list-data-course', require('./teachingDevelopment/listTeacherJobsView/jobs/list-data-course.html'))
  $templateCache.put('details-header-course', require('./teachingDevelopment/listTeacherJobsView/details/details-header-course.html'))
  $templateCache.put('details-header-course-modal', require('./teachingDevelopment/listTeacherJobsView/details/details-header-course-modal.html'))
  $templateCache.put('header-course', require('./teachingDevelopment/listTeacherJobsView/header-course.html'))
}




// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/consolidationCP/consolidation.run.js